var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-chart',{staticClass:"pa-2",attrs:{"path-option":_vm.defaultOption,"height":"400px","width":_vm.width}})}
var staticRenderFns = []
export { render, staticRenderFns }